var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2310_19540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0006 76.3683C60.0859 76.3683 76.3683 60.0859 76.3683 40.0006C76.3683 19.9152 60.0859 3.63281 40.0006 3.63281C19.9152 3.63281 3.63281 19.9152 3.63281 40.0006C3.63281 60.0859 19.9152 76.3683 40.0006 76.3683Z",
    fill: "url(#paint0_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0006 76.3683C60.0859 76.3683 76.3683 60.0859 76.3683 40.0006C76.3683 19.9152 60.0859 3.63281 40.0006 3.63281C19.9152 3.63281 3.63281 19.9152 3.63281 40.0006C3.63281 60.0859 19.9152 76.3683 40.0006 76.3683Z",
    fill: "url(#paint1_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 3.63281C19.9152 3.63281 3.63281 19.9152 3.63281 39.9999C3.63281 60.0846 19.9152 76.3669 39.9999 76.3669C60.0846 76.3669 76.3669 60.0846 76.3669 39.9999C76.3669 19.9152 60.0846 3.63281 39.9999 3.63281ZM39.9999 51.3913C20.2038 51.3913 4.15673 46.2916 4.15673 39.9999C4.15673 33.7081 20.2038 28.6085 39.9999 28.6085C59.796 28.6085 75.843 33.7081 75.843 39.9999C75.843 46.2916 59.796 51.3913 39.9999 51.3913Z",
    fill: "url(#paint2_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9994 51.3917C59.795 51.3917 75.8426 46.2913 75.8426 39.9996C75.8426 33.7079 59.795 28.6074 39.9994 28.6074C20.2038 28.6074 4.15625 33.7079 4.15625 39.9996C4.15625 46.2913 20.2038 51.3917 39.9994 51.3917Z",
    fill: "url(#paint3_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9975 40.2108C79.9991 40.1395 80 40.0692 80 40C80 39.9308 79.9991 39.8605 79.9975 39.7892C79.9431 29.1837 75.7896 19.2209 68.2844 11.7156C60.779 4.21051 50.8163 0.0569412 40.2107 0.0025098C40.1395 0.000941177 40.069 0 40 0C39.931 0 39.8605 0.000941177 39.7893 0.0025098C29.1837 0.0569412 19.221 4.21051 11.7158 11.7158C4.21051 19.221 0.0569412 29.1837 0.0025098 39.7892C0.000941177 39.8605 0 39.931 0 40C0 40.069 0.000941177 40.1395 0.0025098 40.2108C0.0569412 50.8163 4.21035 60.7791 11.7156 68.2844C19.2209 75.7896 29.1835 79.9431 39.7892 79.9975C39.8605 79.9991 39.9308 80 39.9998 80C40.0689 80 40.1393 79.9991 40.2105 79.9975C50.8162 79.9431 60.7788 75.7895 68.2841 68.2844C75.7895 60.779 79.9431 50.8163 79.9975 40.2108ZM64.1272 46.2362C62.1184 47.0126 59.893 47.6791 57.5004 48.2281C57.7307 45.552 57.8494 42.7972 57.8494 40.0002C57.8494 37.2031 57.7307 34.4483 57.5004 31.7722C59.8929 32.3213 62.1184 32.9876 64.1272 33.7641C69.7123 35.923 72.2124 38.4518 72.2124 40.0003C72.2124 41.5485 69.7123 44.0773 64.1272 46.2362ZM40 72.2124C38.4515 72.2124 35.9227 69.7123 33.7638 64.1272C32.9875 62.1184 32.3209 59.893 31.7719 57.5004C34.448 57.7307 37.2028 57.8494 39.9998 57.8494C42.7969 57.8494 45.5517 57.7307 48.2278 57.5004C47.6787 59.8929 47.0124 62.1184 46.2359 64.1272C44.0773 69.7123 41.5485 72.2124 40 72.2124ZM40 50.0618C36.7144 50.0618 33.5076 49.8867 30.4502 49.5498C30.1133 46.4924 29.9382 43.2856 29.9382 40C29.9382 36.7144 30.1133 33.5076 30.4502 30.4502C33.5076 30.1133 36.7144 29.9382 40 29.9382C43.2856 29.9382 46.4924 30.1133 49.5498 30.4502C49.8867 33.5076 50.0618 36.7144 50.0618 40C50.0618 43.2856 49.8867 46.4924 49.5498 49.5498C46.4924 49.8867 43.2856 50.0618 40 50.0618ZM7.78761 40C7.78761 38.4515 10.2877 35.9227 15.8728 33.7638C17.8816 32.9875 20.107 32.3209 22.4996 31.7719C22.2693 34.448 22.1506 37.2028 22.1506 39.9998C22.1506 42.7969 22.2693 45.5517 22.4996 48.2278C20.1071 47.6787 17.8816 47.0124 15.8728 46.2359C10.2877 44.0773 7.78761 41.5485 7.78761 40ZM40 7.78761C41.5485 7.78761 44.0773 10.2877 46.2362 15.8728C47.0126 17.8816 47.6791 20.107 48.2281 22.4996C45.552 22.2693 42.7972 22.1506 40.0002 22.1506C37.2031 22.1506 34.4483 22.2693 31.7722 22.4996C32.3213 20.1071 32.9876 17.8816 33.7641 15.8728C35.9227 10.2877 38.4515 7.78761 40 7.78761ZM69.8046 27.7363C68.8643 27.287 67.907 26.8747 66.9346 26.5001C63.806 25.2908 60.2474 24.3164 56.4014 23.5984C55.6835 19.7525 54.709 16.1939 53.4998 13.0653C53.1252 12.0929 52.7128 11.1356 52.2635 10.1955C56.1489 11.794 59.717 14.162 62.7774 17.2224C65.8381 20.2828 68.206 23.8508 69.8046 27.7363ZM17.2223 17.2224C20.2827 14.162 23.8508 11.794 27.7362 10.1955C27.2869 11.1356 26.8745 12.0929 26.4999 13.0653C25.2907 16.1939 24.3162 19.7525 23.5983 23.5984C19.7523 24.3164 16.1937 25.2908 13.0651 26.5001C12.0928 26.8747 11.1354 27.287 10.1953 27.7363C11.794 23.8508 14.1619 20.2828 17.2223 17.2224ZM10.1955 52.2637C11.1356 52.7129 12.0929 53.1253 13.0653 53.4999C16.1939 54.7092 19.7525 55.6836 23.5984 56.4016C24.3164 60.2475 25.2908 63.8061 26.5001 66.9346C26.8747 67.9069 27.287 68.8642 27.7363 69.8044C23.851 68.2058 20.2828 65.8378 17.2224 62.7774C14.1619 59.7172 11.794 56.1492 10.1955 52.2637ZM52.2637 69.8046C52.7129 68.8644 53.1253 67.9071 53.4999 66.9348C54.7092 63.8061 55.6836 60.2475 56.4016 56.4017C60.2475 55.6838 63.8061 54.7093 66.9348 53.5001C67.9071 53.1255 68.8645 52.7131 69.8047 52.2638C68.2061 56.1493 65.8381 59.7173 62.7777 62.7777C59.7172 65.838 56.1492 68.206 52.2637 69.8046Z",
    fill: "url(#paint4_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59375 51.2305C3.44881 57.6091 6.88708 63.4549 11.715 68.283C19.2203 75.7883 29.1829 79.9417 39.7886 79.9961C39.8599 79.9977 39.9302 79.9986 39.9992 79.9986C40.0683 79.9986 40.1387 79.9977 40.2099 79.9961C50.8155 79.9417 60.7782 75.7881 68.2835 68.283C73.1114 63.4551 76.5497 57.6093 78.4047 51.2305H1.59375ZM17.2215 62.7762C14.1611 59.7158 11.7931 56.1478 10.1945 52.2623C11.1347 52.7116 12.092 53.1239 13.0643 53.4985C16.193 54.7078 19.7516 55.6822 23.5975 56.4002C24.3155 60.2462 25.2899 63.8047 26.4992 66.9332C26.8737 67.9055 27.2861 68.8629 27.7354 69.803C23.8501 68.2046 20.2821 65.8366 17.2215 62.7762ZM46.2355 64.1258C44.0766 69.7109 41.5478 72.211 39.9992 72.211C38.4507 72.211 35.9219 69.7109 33.763 64.1258C32.9867 62.1171 32.3202 59.8916 31.7712 57.499C34.4472 57.7293 37.2021 57.848 39.9991 57.848C42.7961 57.848 45.5509 57.7293 48.227 57.499C47.6781 59.8915 47.0118 62.1171 46.2355 64.1258ZM62.777 62.7762C59.7166 65.8366 56.1484 68.2046 52.2631 69.8032C52.7123 68.863 53.1247 67.9057 53.4993 66.9334C54.7086 63.8047 55.683 60.2462 56.401 56.4004C60.2469 55.6824 63.8055 54.708 66.9341 53.4987C67.9064 53.1241 68.8638 52.7117 69.8039 52.2625C68.2052 56.1478 65.8373 59.7158 62.777 62.7762Z",
    fill: "url(#paint5_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2838 68.2839C71.943 64.6247 74.8029 60.3803 76.7819 55.7631L50.1234 29.1044C49.7078 28.4525 49.0407 27.9477 48.1728 27.77L27.0355 23.4407C24.8945 23.0021 23.0021 24.8945 23.4407 27.0355L27.77 48.1728C27.9477 49.0406 28.4525 49.7078 29.1044 50.1234L55.763 76.7821C60.3803 74.8029 64.6247 71.943 68.2838 68.2839Z",
    fill: "url(#paint6_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4142 45.4648L45.4648 54.4142L63.4575 72.4068C66.892 69.9121 69.9121 66.892 72.4068 63.4575L54.4142 45.4648Z",
    fill: "url(#paint7_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9207 46.9715L45.6295 36.6804L49.5589 32.7511C51.2746 31.0355 50.3933 28.1006 48.0165 27.6137L26.8793 23.2844C24.7383 22.8459 22.8459 24.7383 23.2844 26.8793L27.6137 48.0165C28.1006 50.3933 31.0355 51.2746 32.751 49.559L36.6804 45.6297L46.9715 55.9208C48.1166 57.0659 49.9731 57.0659 51.118 55.9208L55.9208 51.118C57.0656 49.9729 57.0656 48.1165 55.9207 46.9715Z",
    fill: "url(#paint8_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9202 46.9708L45.629 36.6797L36.6797 45.629L46.9708 55.9202C48.1159 57.0653 49.9724 57.0653 51.1173 55.9202L55.9202 51.1173C57.0651 49.9722 57.0651 48.1158 55.9202 46.9708Z",
    fill: "url(#paint9_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4546 37.4031L36.6813 45.6297L32.7519 49.5591C31.0358 51.2736 28.1009 50.3936 27.6146 48.0156L25.7398 38.8642C25.6863 38.6034 25.6984 38.3334 25.775 38.0783C25.8516 37.8233 25.9902 37.5913 26.1785 37.4031C26.8071 36.7745 27.8261 36.7745 28.4546 37.4031Z",
    fill: "url(#paint10_linear_2310_19540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5591 32.7519L45.6297 36.6813L37.4031 28.4546C36.7745 27.8261 36.7745 26.8069 37.4031 26.1784C37.5913 25.9901 37.8233 25.8515 38.0783 25.775C38.3333 25.6984 38.6033 25.6863 38.8641 25.7398L48.0154 27.6146C50.3936 28.1009 51.2736 31.0358 49.5591 32.7519Z",
    fill: "url(#paint11_linear_2310_19540)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2310_19540",
    x1: -6.33976,
    y1: -6.33976,
    x2: 61.2557,
    y2: 61.2557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#518EF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2310_19540",
    x1: 35.8936,
    y1: 35.8936,
    x2: 65.2544,
    y2: 65.2544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2310_19540",
    x1: 39.9999,
    y1: 23.3724,
    x2: 39.9999,
    y2: 3.42858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2310_19540",
    x1: 39.9994,
    y1: 40.4702,
    x2: 39.9994,
    y2: 28.5301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#3D6BE4",
    stopOpacity: 0.161
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#3660BF",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#3259A7",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2310_19540",
    x1: 11.7158,
    y1: 11.7158,
    x2: 68.2842,
    y2: 68.2842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#518EF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2310_19540",
    x1: 39.9992,
    y1: 60.1712,
    x2: 39.9992,
    y2: 78.9952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2310_19540",
    x1: 55.3199,
    y1: 55.3199,
    x2: 35.8462,
    y2: 35.8462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#3D6BE4",
    stopOpacity: 0.161
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#3660BF",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#3259A7",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2310_19540",
    x1: 58.7193,
    y1: 58.7193,
    x2: 47.6788,
    y2: 47.6788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#3D6BE4",
    stopOpacity: 0.161
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#3660BF",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#3259A7",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2310_19540",
    x1: 32.6142,
    y1: 32.6143,
    x2: 49.0832,
    y2: 49.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE7FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2310_19540",
    x1: 49.9732,
    y1: 49.9732,
    x2: 53.7038,
    y2: 53.7038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AAADC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AAADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2310_19540",
    x1: 30.9528,
    y1: 45.9877,
    x2: 33.7784,
    y2: 48.8132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AAADC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AAADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2310_19540",
    x1: 45.9877,
    y1: 30.9528,
    x2: 48.8132,
    y2: 33.7782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AAADC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AAADC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2310_19540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.374e5b3d7fee871951522b84c7b9e774.svg";
export { ForwardRef as ReactComponent };